import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ?
      'bg-white/95 backdrop-blur-md shadow-lg' :
      'bg-transparent'}`
      }>

      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <div className="transition-colors text-2xl font-bold tracking-tight !shadow-2xs !text-[#D65C5C]">


              PrisamTechAi LLC
              <span className={`text-sm font-normal ml-2 ${
              isScrolled ? 'text-slate-600' : 'text-teal-300'}`
              }>

              </span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`font-medium transition-colors hover:text-teal-500 ${
              isScrolled ? 'text-slate-700' : 'text-white'}`
              }>

              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`font-medium transition-colors hover:text-teal-500 ${
              isScrolled ? 'text-slate-700' : 'text-white'}`
              }>

              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`font-medium transition-colors hover:text-teal-500 ${
              isScrolled ? 'text-slate-700' : 'text-white'}`
              }>

              Services
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`font-medium transition-colors hover:text-teal-500 ${
              isScrolled ? 'text-slate-700' : 'text-white'}`
              }>

              Contact
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-teal-500 hover:bg-teal-600 text-white">

              Get a Quote
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 ${isScrolled ? 'text-slate-900' : 'text-white'}`}>

            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen &&
        <div className="md:hidden mt-4 pb-4 space-y-4">
            <button
            onClick={() => scrollToSection('home')}
            className="block w-full text-left py-2 text-slate-700 hover:text-teal-500">

              Home
            </button>
            <button
            onClick={() => scrollToSection('about')}
            className="block w-full text-left py-2 text-slate-700 hover:text-teal-500">

              About
            </button>
            <button
            onClick={() => scrollToSection('services')}
            className="block w-full text-left py-2 text-slate-700 hover:text-teal-500">

              Services
            </button>
            <button
            onClick={() => scrollToSection('contact')}
            className="block w-full text-left py-2 text-slate-700 hover:text-teal-500">

              Contact
            </button>
            <Button
            onClick={() => scrollToSection('contact')}
            className="w-full bg-teal-500 hover:bg-teal-600 text-white">

              Get a Quote
            </Button>
          </div>
        }
      </div>
    </header>);

};

export default Header;